module.exports = __webpack_public_path__ + "static/media/dashboard2.a228086a.png";